import React            from 'react';
import FormErrorMessage from 'components/ui/form/form_error_message';
import { fieldWrapper } from 'components/ui/json_form/fields/field_wrapper';

const MultiButton = ({
  input,
  label,
  list,
  onSelected,
  meta,
  className,
  disabled,
  onValueChange,
}) => {

  const onSelect = (selected) => {
    input.onChange(selected && selected.value.toString());
    if (onSelected) {
      onSelected(selected && selected);
    }
    if (onValueChange) {
      onValueChange(selected.value);
    }
  };
  return (
    <div
      className="field uk-button-group"
      data-purpose={ input.name }
    >
      { list.map(item => (
        <button
          key={ item.value }
          className={ `uk-button uk-button-small ${ item.value.toString() === input.value.toString() ? 'selected uk-button-primary' : 'uk-button-default' } ${ className || '' }` }
          type="button"
          disabled={ disabled }
          data-purpose={ `${ item.value.toLowerCase() }_button` }
          onClick={ () => onSelect(item) }
        >
          { item.label }
        </button>
      )) }
      <FormErrorMessage { ...meta } name={ input.name } label={ label } />
    </div>
  );
};

export default fieldWrapper()(MultiButton);
